module.exports = __webpack_public_path__ + "img/slide1.5d540885.jpg";